import { TableRow as MuiTableRow } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import theme from '../theme';

const {
  colors: { tableRowBackgroundHoverColor },
} = theme;

const TableRow = ({ active, children, className, onClick, ...props }) => {
  const { classes, cx } = useStyles(styles);

  return (
    <MuiTableRow
      className={cx(
        classes.tableRow,
        className,
        onClick && 'clickable',
        active && 'active'
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </MuiTableRow>
  );
};

const styles = () => ({
  tableRow: {
    backgroundColor: '#fff',
  },
});

TableRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
};

export default TableRow;
